import { CommonModule } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  Input,
  OnInit,
} from '@angular/core';
import { RouterService } from '@app/core';
import { CategoryModel } from '@app/core/models';
import { LoggingService } from '@app/core/services/logging/logging.service';
import { SortCategoriesPipe } from '@app/shared/pipes/sort-categories.pipe';
import {
  BookingRepository,
  CategoriesRepository,
  ServicesRepository,
} from '@app/store';
import { IonicModule } from '@ionic/angular';
import { TranslocoPipe } from '@jsverse/transloco';
import { AlertComponent } from '../alert/alert.component';

@Component({
  selector: 'app-categories-grid',
  imports: [
    IonicModule,
    CommonModule,
    TranslocoPipe,
    AlertComponent,
    SortCategoriesPipe,
  ],
  templateUrl: './categories-grid.component.html',
  styleUrls: ['./categories-grid.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CategoriesGridComponent implements OnInit {
  @Input() showHeader: boolean = true;

  categoriesFiltered: CategoryModel[] = [];
  isProcessing = true;

  constructor(
    public categoriesRepo: CategoriesRepository,
    public bookingRepo: BookingRepository,
    public servicesRepo: ServicesRepository,
    private _routerService: RouterService,
  ) {}

  ngOnInit() {
    LoggingService.log('categories component init');
  }

  navigateToAllServicesPage() {
    this._routerService.navigateToAllServicesPage();
  }

  handleCategoryClick(category: CategoryModel) {
    this._routerService.navigateToServicesByCategoryPage(category._id);
  }

  getCategoryLabelWithoutSpaces(label: string) {
    if (!label) return '';
    return label?.replace(/\s+/g, '-').replace(/&/g, 'and').toLowerCase();
  }
}
